import { Box, List, ListItem } from "@material-ui/core"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import React, { Fragment, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import * as actionCommon from "../../store/actions/commonActions"
import {
  MenuIcon,
  NotificationIcon,
  SearchIcon,
  SettingIcon,
} from "../ButtonStyle/SimpleBtn"
import LogoMain from "../Logo/LogoMain"
import AccountMenu from "../MainMenu/AccountMenu"
import MainMenu from "../MainMenu/MainMenu"
import { NotificationsPopup } from "../Notifications"
import Avator from "../user/Avator"
import SearchField from "./SearchField"

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: 0,
    width: "auto",
  },
}))

const Header = () => {
  const {
    error,
    userNotifications,
    userSetting,
    menuMobileClasses,
  } = useSelector(state => ({
    userNotifications: state.common.userNotifications,
    error: state.common.error,
    userSetting: state.common.userSetting,
    menuMobileClasses: state.common.menuMobileClasses,
    searchClasses: state.common.searchClasses,
  }))

  const dispatch = useDispatch()
  const [showSearch, setShowSearch] = useState(false)

  const mainMenuToggle = event => {
    dispatch(actionCommon.menuMobile(" hbku-nav-toggle"))
    event.preventDefault()
  }
  const settingToggle = event => {
    dispatch(actionCommon.userSettingPop(true))
    event.preventDefault()
  }
  const notificationsToggle = event => {
    dispatch(actionCommon.userNotificationsPop(true))
    event.preventDefault()
  }

  const searchToggle = event => {
    setShowSearch(true)
    dispatch(actionCommon.searchClassesToggle(" navbar-search-toggle"))
    event.preventDefault()
  }

  const closeSearch = event => {
    setShowSearch(false)
    dispatch(actionCommon.searchClassesToggle(""))
    event.preventDefault()
  }
  const classes = useStyles()
  return (
    <Fragment>
      <Box
        component="nav"
        className="navbar navbar-expand-xl navbar-light fixed-top hbku-navbar"
      >
        <MenuIcon MainMenuClickFun={mainMenuToggle} />
        <LogoMain />
        <List className="navbar-nav hk-navbar-content">
          <ListItem className={classes.listItem + " " + "nav-item"}>
            <SearchIcon searchClickFun={searchToggle} />
          </ListItem>
          <ListItem className={classes.listItem + " " + "nav-item"}>
            <SettingIcon />
          </ListItem>
          <ListItem
            className={
              classes.listItem +
              " " +
              "nav-item dropdown dropdown-notifications"
            }
          >
            <NotificationIcon NotificationClickFun={notificationsToggle} />

            {userNotifications ? <NotificationsPopup /> : null}
          </ListItem>
          <ListItem
            className={
              classes.listItem +
              " " +
              "nav-item dropdown dropdown-authentication"
            }
          >
            <Avator ProfileMediaClickFun={settingToggle} />
            {userSetting ? <AccountMenu /> : null}
          </ListItem>
        </List>
      </Box>
      {showSearch ? <SearchField openSearchField={closeSearch} /> : null}
      <MainMenu />
    </Fragment>
  )
}
export default Header
